import React from "react";
import ScrollToTop from "./common/ScrollToTop";
import { FiChevronUp } from "react-icons/fi";
import { useTranslation } from "react-i18next";
import PageHelmet from "./common/Helmet";
import Breadcrumb from "./common/Breadcrumb";
import Header from "./common/Header";
import FooterTwo from "./common/FooterTwo";
import EvidenceBrowser from "./evidence/EvidenceBrowser";

/** Standalone /evidence page: site chrome around the embeddable
 *  EvidenceBrowser (which owns the filters, results, URL sync and the
 *  Search|Network mode toggle). */

const Evidence = () => {
  const { t } = useTranslation();
  const section = t("evidence.title", "Domain evidence browser");

  return (
    <>
      <PageHelmet pageTitle={section} />
      <Header />
      <Breadcrumb backgroundSection="About" title={section} />

      <div className="designer-portfolio-area ptb--120 bg_color--1">
        <div className="wrapper plr--70 plr_sm--30 plr_md--30">
          <EvidenceBrowser />
        </div>
      </div>

      <div className="backto-top">
        <ScrollToTop showUnder={160}>
          <FiChevronUp />
        </ScrollToTop>
      </div>

      <FooterTwo />
    </>
  );
};

export default Evidence;
